<template>
    <v-dialog v-model="dialog" width="600">
        <v-card>
            <v-card-title class="headline">
                Zmień opis
            </v-card-title>
            <v-card-text>
                <v-form
                    ref="newForm"
                    v-model="valid"
                    lazy-validation
                    class="dimension--form mt-5 mb-5"
                >
                    <v-row>
                        <v-col cols="12" md="12" align-self="start" dense>
                            <v-textarea
                                v-model="data.additionalInfo"
                                :rules="formRules.additionalInfo"
                                class="pt-0"
                                label="Opis odpadu"
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click.prevent="onSubmit"
                            type="Submit"
                            class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                            large
                        >Zmień<v-icon size="24">mdi-send</v-icon>
                        </v-btn
                        >
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";

export default {
    name: 'ModalSetDescription',
    props: {
        order: {},
    },
    created() {
    },
    data() {
        return {
            dialog: false,
            formRules: {
              additionalInfo: [(value) => !!value || 'Uzupełnij opis'],
            },
            valid: false,
            data: {
              additionalInfo: '',
            },
        }
    },
    methods: {
        open() {
            this.dialog = true;

          console.log(this.order.additionalData);
            this.data.additionalInfo = this.order.additionalData['Opis odpadu'];
        },
        async onSubmit() {
            if (!this.$refs.newForm.validate()) {
                return
            }

            api
                .put(`/api/orders/${this.order.id}`, {
                  additionalInfo: this.data.additionalInfo
                })
                .then(() => {
                    this.$root.$emit('notifySuccess', {
                        html: 'Zmieniono opis.',
                    });
                    this.dialog = false;
                    this.$parent.loadDetails();
                })
                .catch((error) => {
                    console.error('Error when editing a redirect:', error);
                    this.$root.$emit('notifyError', {
                        html: 'Wystąpił błąd podczas zmiany ilości',
                    });
                })
        },
    },
}
</script>

<style scoped></style>
